var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.basicCard,style:({ width: _vm.width, paddingBottom: _vm.paddingBottom ? '5rem' : '' })},[_vm._t("default"),_vm._t("btnArea")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }